export const InitialValuesAddPartnerMarketPlace = {
	title: "",
	logoUrl: "",
	imageUrl: "",
	description: "",
	categoryIri: "",
	email: "",
	transmission: "",
	active: "",
}